/*
 * @Author: kongxiangyu
 * @Date: 2022-11-07 14:08:55
 * @LastEditTime: 2023-02-09 16:52:00
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
 */
/**
 * @file StatisticConst.js
 * @desc 统计日志埋点静态文件
 * @author ~~
 * @data 2020/06/18
 */
import statisticAction from '@/common/utils/statisticAction';
import {getParamsFromUrl} from '@baidu/map-fe-utils';

const statisticConst = {};
const fr = getParamsFromUrl().fr || 'default';
const sendStatisticalInfo = statisticAction.submitStatisticalInfo;

statisticConst.pageShow = () => {
    sendStatisticalInfo('cjh.foodValentine2023.pageShow', {fr});
};

statisticConst.nativeOutShow = () => {
    sendStatisticalInfo('cjh.foodValentine2023.nativeOutShow', {fr});
};

statisticConst.getRedPacket = () => {
    sendStatisticalInfo('cjh.foodValentine2023.getRedPacket', {fr});
};
// 免费美食券show
statisticConst.freeMsShow = () => {
    sendStatisticalInfo('cjh.foodValentine2023.freeMsShow', {fr});
};

// 免费美食券点击
statisticConst.freeMsClick = () => {
    sendStatisticalInfo('cjh.foodValentine2023.freeMsClick', {fr});
};

// 免费加油券show
statisticConst.freeJyShow = () => {
    sendStatisticalInfo('cjh.foodValentine2023.freeJyShow', {fr});
};

// 免费美食券点击
statisticConst.freeJyClick = () => {
    sendStatisticalInfo('cjh.foodValentine2023.freeJyClick', {fr});
};

// 饮品小吃券展现
statisticConst.tianmiyushou = () => {
    sendStatisticalInfo('cjh.foodValentine2023.tianmiyushouShow', {fr});
};

// 饮品小吃券点击
statisticConst.tianmiyushouClick = () => {
    sendStatisticalInfo('cjh.foodValentine2023.tianmiyushouClick', {fr});
};

// 正餐券展现
statisticConst.zhengcanShow = () => {
    sendStatisticalInfo('cjh.foodValentine2023.zhengcanShow', {fr});
};

// 正餐券点击
statisticConst.zhengcanClick = () => {
    sendStatisticalInfo('cjh.foodValentine2023.zhengcanClick', {fr});
};

// 券包展现
statisticConst.packageShow = () => {
    sendStatisticalInfo('cjh.foodValentine2023.packageShow', {fr});
};

// 券包click
statisticConst.packageClick = () => {
    sendStatisticalInfo('cjh.foodValentine2023.packageClick', {fr});
};

// 商品click
statisticConst.goodsClick = ({id, module}) => {
    sendStatisticalInfo('cjh.foodValentine2023.goodsClick', {
        fr,
        id,
        module
    });
};

// 分享
statisticConst.share = () => {
    sendStatisticalInfo('cjh.foodValentine2023.share', {fr});
};

// 订单中心
statisticConst.order = () => {
    sendStatisticalInfo('cjh.foodValentine2023.order', {fr});
};

// 我的券包
statisticConst.myPackage = () => {
    sendStatisticalInfo('cjh.foodValentine2023.myPackage', {fr});
};

// 秒杀
statisticConst.miaosha = () => {
    sendStatisticalInfo('cjh.foodValentine2023.miaosha', {fr});
};

export default statisticConst;